import {
    IAuthenticationFlow,
    IAuthenticationFlowRunner,
    ILoginOptions,
    IAuthenticationStorage,
} from '../models';
import { CrossAuthenticationFlow } from '../flows/cross-authentication-flow';
import { MigrationAuthenticationFlow } from '../flows/migration-authentication-flow';
import { LoaderManager } from '../../../loaders/LoaderManager';
import { ILogger } from '@sparkware/uc-sdk-core';
import { Container } from 'typedi';
import { LoggerProvider } from '../../logger';

export class CrossAuthenticationFlowRunner implements IAuthenticationFlowRunner {
    private readonly _logger: ILogger;

    private get _authenticationStoragePromise(): Promise<IAuthenticationStorage> {
        return LoaderManager.Instance.AuthenticationStorageLoader.Instance;
    }

    constructor() {
        this._logger = Container.get(LoggerProvider).getLogger('CrossAuthenticationFlowRunner');
    }

    public execute = async (options?: ILoginOptions): Promise<void> => {
        this._logger.debug(`[execute] started, options: ${options}`);
        const authenticationStorage = await this._authenticationStoragePromise;
        if (options) {
            authenticationStorage.setLoginOptions(options);
        }
        const listOfFlows: Array<IAuthenticationFlow> = [
            new CrossAuthenticationFlow(),
            new MigrationAuthenticationFlow(),
        ];

        for (let flow of listOfFlows) {
            const flowResponse = await flow.start();
            if (!flowResponse.continue) {
                this._logger.debug(`[execute] stopped at flow type: ${flow?.type}`);
                break;
            }
        }
        this._logger.debug(`[execute] end`);
    };
}
